import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, ModalBody, ModalHeader, Table } from "reactstrap";
import {
  getBookingList,
} from "../../redux/actions/indexActions";
import { AiOutlineDelete, AiOutlineEye } from "react-icons/ai";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { Button } from "reactstrap";
import { MdAdd } from "react-icons/md";
import { Input } from "reactstrap";
import Pagination from "../../Components/Paginate";
import moment from "moment/moment";

const BookingIndex = () => {
  const dispatch = useDispatch();
  const {
    AuthReducer: { auth },
    indexReducer: {
      BookingLists,
      bookingCount,
    },
    PermissionReducer: { allowedPermissions },
  } = useSelector((state) => state);
  const [bookingDetails, setBookingDetails] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [modal, setModal] = useState(false);
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState('desc');
  const [paginate, setPaginate] = useState(10);
  const [qrCodeUrl, setQrCodeUrl] = useState("");
  const indexOfLastItem = (page + 1) * paginate;
  const indexOfFirstItem = indexOfLastItem - paginate;
  useEffect(() => {
    dispatch(getBookingList(auth?.token, paginate, page, sort))
  }, [auth, paginate, page, sort]);

  const toggle = () => setIsOpen((prev) => !prev);

  const handleDel = (id) => {
    if (window.confirm("Are You Sure You Want To Delete This Booking")) {
      axios
        .delete(`/api/admin/v1/booking-delete/${id}`, {
          headers: {
            Authorization: `Bearer ${auth?.token}`,
          },
        })
        .then((res) => {
          toast.success(res.data.message);
          dispatch(getBookingList(auth?.token));
        })
        .catch((err) => toast.error("Somthing Went Wrong"));
    }
  };

  const handleViewQR = (qrCode) => {
    setQrCodeUrl(qrCode); // Set the QR code image URL
    setModal(true); // Open the modal
  };

  return (
    <div>
      <div className="row my-3">
        <div className="col-md-12">
          <div className="mb-4 d-flex align-items-center justify-content-between" >
            <h5 className="mb-0 text-white fs-4">Booking List</h5>
            {/* {allowedPermissions?.some?.((item) => item?.permission?.moduleType === "EVENTS" && item?.permission?.permission === "create") && (
              <Link to="/add-event">
                <Button className="bg-white text-black" size="sm">
                  <span className="me-2">
                    <MdAdd size={22} />
                  </span>
                  Add Event
                </Button>
              </Link>
            )} */}
          </div>
        </div>
      </div>
      <div className="bg-white px-3 py-4 rounded-2  my-4" style={{ boxShadow: "4px 4px 18px rgba(0,0,0,0.15)" }}>

        <div className="row">
          <div className="col-md-3 mb-2">
            <Input size={"sm"} value={search} placeholder='Search By Name' onChange={(({ target: { value } }) => setSearch(value))} />
          </div>
          <div className="col-md-2 offset-md-7">
            <Input type="select" size={"sm"} value={sort} onChange={(({ target }) => setSort(target.value))} >
              <option value="asc">Ascending</option>
              <option value="desc">Descending</option>
            </Input>
          </div>
          <div className="col-md-12">
            <Table hover responsive>
              <thead>
                <tr>
                  <th>SL. No.</th>
                  <th>Booking Place</th>
                  <th>Booked By</th>
                  <th>Booked Date</th>
                  <th>QR Code</th>
                  <th>Booked Through</th>
                  <th>No. Of People</th>
                  <th>Booking Date</th>
                  {allowedPermissions?.some?.((item) => item?.permission?.moduleType === "EVENTS" && item?.permission?.permission === "delete") && (
                    <th>Action</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {BookingLists.length === 0 ? (
                  <tr>
                    <td colSpan="6">No data found</td>
                  </tr>
                ) : (<>
                  {BookingLists?.map?.((item, index) => {
                    return (
                      <tr key={item.id}>
                        <th scope="row">{index + 1 + page * paginate}</th>
                        <td>{item?.place?.place_name}</td>
                        <td>{item?.user?.name}</td>
                        <td>{moment(item?.booking_date).format("DD-MM-yyyy")}</td>
                        <td>
                          <Button
                          size="sm"
                            onClick={() => handleViewQR(process.env.REACT_APP_IMAGE_URL + `/${item?.qr_code}`)}
                          >
                            View QR
                          </Button>
                        </td>
                        <td>{item?.mobile}</td>
                        <td>{item?.no_of_people}
                          <span
                            role="button"
                            title="View Booked Users"
                            onClick={() => {
                              setBookingDetails(item);
                              toggle();
                            }}
                          >
                            <AiOutlineEye size={22} style={{ margin: 10 }} />
                          </span></td>
                        <td>{moment(item?.createdAt).format("DD-MM-yyyy hh:mm A")}</td>
                        <td>
                          <div className="d-flex align-items-center">
                            {allowedPermissions?.some?.(
                              (item) =>
                                item?.permission?.moduleType ===
                                "EVENTS" &&
                                item?.permission?.permission === "delete"
                            ) && (
                                <AiOutlineDelete
                                  size={22}
                                  className="text-danger"
                                  onClick={() => handleDel(item.id)}
                                />
                              )}
                          </div>
                        </td>
                      </tr>
                    );
                  })}</>
                )}
              </tbody>
            </Table>
          </div>
        </div>
        <Modal isOpen={isOpen} toggle={toggle} size="sm">
          <ModalHeader toggle={toggle}>Visitors Name</ModalHeader>
          <ModalBody>
            <div className="col-md-12">
              <div className="mt-1">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <td>S.No.</td>
                      <td>Name</td>
                    </tr>
                  </thead>
                  <tbody>
                    {bookingDetails?.booked_users?.map((it, index) => {
                      return (
                        <tr key={it.id}>
                          <td>{index + 1}</td>
                          <td>{it?.name}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Modal isOpen={modal} toggle={() => setModal(false)} size="sm">
          <ModalHeader toggle={() => setModal(false)}>QR Code</ModalHeader>
          <ModalBody>
            <img src={qrCodeUrl} alt="QR Code" style={{ display: "block", marginLeft: "auto", marginRight: "auto", width: "100%" }} />
          </ModalBody>
        </Modal>
        <div className="row align-items-center">
          <div className="col-md-6 d-flex">
            <div className="col-md-2">
              <Input
                type="select"
                id="paginate"
                onChange={e =>
                  setPaginate(
                    e.target.value
                  )
                }
                value={paginate}
                className="paging custom-select custom-select-page m-0"
              >
                <option value="10">
                  10
                </option>
                <option value="20">
                  20
                </option>
                <option value="50">
                  50
                </option>
                <option value="100">
                  100
                </option>
                <option value="200">
                  200
                </option>
                <option value="500">
                  500
                </option>
              </Input>
            </div>
            <div className='col-md-10 text-black d-flex align-items-center ps-3'>
              {bookingCount > 0 ? (
                <>
                  Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, bookingCount)} of {bookingCount} entries
                </>
              ) : (
                <>
                  Showing 0 to 0 of 0 entries
                </>
              )}
            </div>
          </div>
          <div className='col-md-6'>
            <div className='d-flex justify-content-end'>
              <Pagination
                pageCount={(bookingCount) / paginate}
                onChange={(e) => setPage(e.selected)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingIndex;
